import React from "react";
import styled from "styled-components";
import {
  FlexRow,
  LeftContent,
} from "../../../styles/styled-components-utils";
import HighlightText from "../../shared/HighlightText";

const Container = styled(FlexRow)`
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0 28px 25px;
`;

const Text = styled.p`
  text-align: left;
  padding: 0 10px;
  flex: 1 1 auto;
  margin: 0 0 10px;
  box-sizing: border-box;
  max-width: 100%;
  min-width: 50%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Column = styled(LeftContent)`
  flex: 1 1 0;
  justify-content: flex-start;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 28px;
`;

const ResultTitleFrame = ({ textArray, detailsLink, searchQuery }) => {
  const input = textArray.slice(0, 6);
  if (textArray.length > 6) {
    input[5] = detailsLink;
  }

  return (
    <Container>
      {input.map((text, index) => (
        <Text key={index}>
          {typeof text === "string" ? (
            <HighlightText text={text} query={searchQuery} />
          ) : (
            text
          )}
        </Text>
      ))}
    </Container>
  );
};

export default ResultTitleFrame;
